import React from 'react';
import { Home } from './home/Home';
import { menus } from './menu/menuJson';
import { HelpMenuDashboard, DefaultDashboard } from '../dashboard';
import ListMachine from './component/ListMachine';
import { ImcGeneric } from './component/ImcGeneric/ImcGeneric';
import { Alcoholimetria } from './component/Alcolimetria/Alcolimetria';
import { PanelUserMachine } from './UserMachine/PanelUserMachine';
import { UserProfile } from './userProfile/userProfile';
import { PanelUsers } from './generalUsers/PanelUsersGeneral';
import { PanelUserDetail } from './UserDetails/PanelUserDetail';
import { PanelAlcoholimetria } from './alcoholimetro/PanelAlcoholimetria';
import { PanelUserAuth } from './users_auth/panelUsersAuth'
import HistorialUser from './UserMachine/component/hitorialUser';
import PreinformeUser from './UserMachine/component/preinformeUser';
import MedicionesUser from './UserMachine/component/medicionesUser';
import { Reporte } from './component/Alcolimetria/reporte';
import { HomeSuport } from './home/HomeSuport';
import Mantenimiento from './component/Mantenimiento/matenimiento';
import Documento from '../polls/compoment/documentos';
import Registro from './component/RegistroUsuarios/Registro';
import Clientes from './component/RegistroUsuarios/Clientes';
import Administracion from './component/ListMachine/Administracion/Administracion';
import Años from './component/ListMachine/Administracion/Años';
import EvbisAsignadas from './component/RegistroUsuarios/EvbisAsignadas';
import Ubicaciones from './component/ListMachine/Ubicaciones/Ubicaciones';
import { ListModulos } from './component/ListMachine/ListModulos';
import { ModulosGenerales } from './component/ListMachine/Administracion/ModulosGenerales';
import { MultifiltrosGeneral } from './component/ListMachine/Administracion/MultifiltrosGeneral';
import { Datos } from './component/ListMachine/RegistroDeMediciones/Datos';
import { RegistroDeMediciones } from './component/ListMachine/RegistroDeMediciones/RegistroDeMediciones';
import { RegistroAlcohol } from './component/ListMachine/RegistroDeMediciones/RegistroAlcohol';
import { ValidacionDeCitas } from './component/ListMachine/ValidacionDeCitas/ValidacionDeCitas';
import { RegistrosDeUso } from './component/RegistrosDeUso';
import { DashboardInforme } from './component/DashboardInforme/DashboardInforme';


export const CentralDeVida = () => {

  const components = {
    Default: DefaultDashboard,
    Home: Home,
    DashboardInforme: DashboardInforme,
    UserTable: PanelUserMachine,
    ListMachine: ListMachine,
    ImcGeneric: ImcGeneric,
    Alcoholimetria: Alcoholimetria,
    ProfileUser: UserProfile,
    PanelUsersRegular: PanelUsers,
    UsersTableDetail: PanelUserDetail,
    PanelAlcohoL: PanelAlcoholimetria,
    PanelUsers: PanelUserAuth,
    historialUser: HistorialUser,
    preinformeUser: PreinformeUser,
    medicionesUser: MedicionesUser,
    reporte: Reporte,
    HomeSuport: HomeSuport,
    Documento: Documento,
    Mantenimiento: Mantenimiento,
    Registro: Registro,
    Clientes: Clientes,
    Administracion: Administracion,
    Años: Años,
    EvbisAsignadas: EvbisAsignadas,
    Ubicaciones: Ubicaciones,
    ListModulos: ListModulos,
    ModulosGenerales: ModulosGenerales,
    MultifiltrosGeneral: MultifiltrosGeneral,
    Datos: Datos,
    RegistroDeMediciones: RegistroDeMediciones,
    RegistroAlcohol: RegistroAlcohol,
    ValidacionDeCitas: ValidacionDeCitas,
    RegistrosDeUso: RegistrosDeUso

  };

  return (
    <>
      {HelpMenuDashboard().RenderMenu(menus(), components)}
    </>
  );
}
